import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ComponentFactory,
  ComponentFactoryResolver,
  ComponentRef,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { LayoutService } from "@sharedV11/services/layouts/layout.service";

@Component({
  selector: "app-panelcustoman",
  templateUrl: "./panel.customan.html",
  styleUrls: ["./panel.customan.css"],
})
export class PanelCustoman implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @ViewChild("target", { read: ViewContainerRef, static: false })
  target: ViewContainerRef;
  @ViewChild("panel", { read: ElementRef, static: false })
  panelRef: ElementRef<HTMLElement>;
  componentRef: ComponentRef<any>;
  @Output() update = new EventEmitter();
  @Input() pkId;
  @Input() mode;
  @Input() ConfigPanel;
  @Input() modificar: boolean = true;
  @Input() otherProps: { [key: string]: any };
  @Input() ConfigData: any;

  private previousBodyOverflow: string | null = null;
  private destroy$ = new Subject<void>();
  private overlayInnerScrollLockActive = false;

  overlayLeft = 0;
  overlayWidth =
    typeof window !== "undefined" ? Math.max(0, window.innerWidth) : 1024;

  private readonly onWindowResize = () => {
    this.updateOverlayGeometry();
    this.syncOverlayScrollMode();
    this.cdr.detectChanges();
  };

  constructor(
    private resolver: ComponentFactoryResolver,
    private layoutService: LayoutService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.layoutService.sidebar_opened
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.scheduleOverlayGeometry());
    if (typeof window !== "undefined") {
      window.addEventListener("resize", this.onWindowResize);
    }
  }

  ngAfterViewInit() {
    this.createComponent(
      this.ConfigPanel,
      this.pkId,
      this.mode,
      this.modificar,
      this.ConfigData,
      this.otherProps
    );

    if (typeof document !== "undefined" && document.body) {
      this.previousBodyOverflow = document.body.style.overflow || "";
      document.body.style.overflow = "hidden";
    }

    this.scheduleOverlayGeometry();
    this.queueSyncOverlayScrollMode();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["ConfigData"] && this.componentRef) {
      this.componentRef.instance.sourceRecord =
        changes["ConfigData"].currentValue?.sourceRecord;
    }
  }

  ngOnDestroy(): void {
    this.clearOverlayInnerScrollLock();
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onWindowResize);
    }
    this.destroy$.next();
    this.destroy$.complete();
    if (typeof document !== "undefined" && document.body) {
      if (this.previousBodyOverflow !== null) {
        document.body.style.overflow = this.previousBodyOverflow;
      } else {
        document.body.style.overflow = "";
      }
    }
  }

  addDocument(docid: string, doctype: string) {}

  createComponent(
    ConfigPanel,
    pkId,
    mode,
    modificar?,
    configData?: any,
    otherProps?: { [key: string]: any }
  ) {
    this.target.clear();
    if (ConfigPanel) {
      const factory: ComponentFactory<any> =
        this.resolver.resolveComponentFactory(ConfigPanel);
      this.componentRef = this.target.createComponent(factory);
      this.componentRef.instance.pkId = pkId;
      this.componentRef.instance.mode = mode;
      if (modificar !== undefined) {
        this.componentRef.instance.modificar = modificar;
      }
      if (otherProps) this.componentRef.instance.otherProps = otherProps;
      if (this.ConfigData) {
        Object.keys(this.ConfigData).forEach((key) => {
          this.componentRef.instance[key] = this.ConfigData[key];
        });
      }
      if (configData)
        this.componentRef.instance.sourceRecord = configData.sourceRecord;
      this.componentRef.changeDetectorRef.detectChanges();
      this.queueSyncOverlayScrollMode();
    }
  }

  /** Com `.panel-scroll-body` no conteúdo, o scroll fica só nele (uma barra à direita do branco). */
  private syncOverlayScrollMode(): void {
    const overlay = this.panelRef?.nativeElement;
    if (!overlay) {
      return;
    }
    const inner = overlay.querySelector(".panel-scroll-body");
    if (inner) {
      overlay.style.setProperty("overflow-y", "hidden");
      overlay.style.setProperty("overflow-x", "hidden");
      this.overlayInnerScrollLockActive = true;
    } else if (this.overlayInnerScrollLockActive) {
      overlay.style.removeProperty("overflow-y");
      overlay.style.removeProperty("overflow-x");
      this.overlayInnerScrollLockActive = false;
    }
  }

  private clearOverlayInnerScrollLock(): void {
    const overlay = this.panelRef?.nativeElement;
    if (!overlay || !this.overlayInnerScrollLockActive) {
      return;
    }
    overlay.style.removeProperty("overflow-y");
    overlay.style.removeProperty("overflow-x");
    this.overlayInnerScrollLockActive = false;
  }

  private queueSyncOverlayScrollMode(): void {
    if (typeof window === "undefined") {
      return;
    }
    setTimeout(() => this.syncOverlayScrollMode(), 0);
    setTimeout(() => this.syncOverlayScrollMode(), 50);
    setTimeout(() => this.syncOverlayScrollMode(), 200);
  }

  private updateOverlayGeometry(): void {
    if (typeof document === "undefined") {
      return;
    }

    const main =
      (document.getElementById("eltope") as HTMLElement | null) ||
      (document.querySelector("mat-sidenav-content") as HTMLElement | null);

    if (main) {
      const r = main.getBoundingClientRect();
      this.overlayLeft = Math.max(0, Math.round(r.left));
      this.overlayWidth = Math.max(320, Math.round(r.width));
      return;
    }

    this.overlayLeft = 0;
    this.overlayWidth =
      typeof window !== "undefined"
        ? Math.max(320, window.innerWidth)
        : 1024;
  }

  private scheduleOverlayGeometry(): void {
    const run = () => {
      this.updateOverlayGeometry();
      this.syncOverlayScrollMode();
      this.cdr.detectChanges();
    };
    setTimeout(run, 0);
    setTimeout(run, 120);
    setTimeout(run, 300);
    this.queueSyncOverlayScrollMode();
  }
}
